import React from 'react';
interface LinkThumbnail {
  url: string;
  title: string;
  image?: string;
  description?: string;
  siteName?: string;
}
interface LinkThumbnailsProps {
  links: LinkThumbnail[] | undefined;
}
const LinkThumbnails = ({
  links
}: LinkThumbnailsProps) => {
  if (!links || links.length === 0) return null;
  return <div className="mb-6" data-id="element-1917">
      <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-1918">Related Links</h3>
      <div className="flex flex-col gap-3" data-id="element-1919">
        {links.map((link, idx) => <a key={idx} href={link.url} target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg overflow-hidden shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col sm:flex-row" data-id="element-1920">
            {link.image ? <div className="sm:w-1/4 h-32 sm:h-auto bg-gray-100 overflow-hidden" data-id="element-1921">
                <img src={link.image} alt={link.title} className="w-full h-full object-cover" data-id="element-1922" />
              </div> : <div className="sm:w-1/4 h-32 sm:h-auto flex items-center justify-center bg-gray-200" data-id="element-1923">
                <span className="text-gray-500 text-sm" data-id="element-1924">No image</span>
              </div>}
            <div className="p-4 flex-1" data-id="element-1925">
              <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-1926">
                {link.title}
              </p>
              {link.description && <p className="text-xs text-gray-600 mb-2 line-clamp-2" data-id="element-1927">
                  {link.description}
                </p>}
              <div className="flex items-center" data-id="element-1928">
                <div className="w-4 h-4 bg-gray-100 rounded-full overflow-hidden mr-2" data-id="element-1929">
                  <img src={`https://www.google.com/s2/favicons?domain=${link.url}&sz=64`} alt="" className="w-full h-full" data-id="element-1930" />
                </div>
                <p className="text-xs text-gray-500" data-id="element-1931">
                  {link.siteName || new URL(link.url).hostname.replace('www.', '')}
                </p>
              </div>
            </div>
          </a>)}
      </div>
    </div>;
};
export default LinkThumbnails;